import React from "react"
import SectionWrapper from "../../sectionwrapper.component.jsx"
import { getVerticalAlignmentClassName } from "./helpers"
import { Section } from "./types"
import { SectionComponent } from "./SectionContent"
import {Intl} from "../../../../state/helpers/IntlProps"
import {injectIntl} from "react-intl"


interface Props {
    id: string
    editable: boolean
    isPdf: boolean
    isDummy: boolean
    section: Section
    variables: unknown
    onEdit: (args: unknown) => unknown
    intl: Intl
 }
 
const TextAndImageRowContentSection: React.FC<Props> = (props) => {
 
    const rowContent = props.section.attributes.content
    const columnWidthMd = 12/rowContent.nbColumns //bootstrap column width for large (md-sized +) screens

    return (
        <SectionWrapper
            id={props.id}
            section={props.section}
            onEdit={props.onEdit}
            editable={props.editable}
            variables={props.variables}
        >
            <div className={`py-2 col-12 mb-1 d-flex align-items-${getVerticalAlignmentClassName(rowContent.verticalAlignment)}`}>
                { rowContent.cells?.map((cell, i) => (
                    <SectionComponent key={i} columnWidthMd={columnWidthMd} {...props} cell={cell} />
                ))}
            </div>
        </SectionWrapper>
    )
}

export default injectIntl(TextAndImageRowContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/section.component.tsx